<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <loader v-if="isLoading" />
            <div class="page">
                <!-- ALERTAS -->
                <alert-container :messages="msgs" />

                <div class="pedidos vertical-flow">
                    <!-- TÍTULO, BREADCRUMB E BOTÕES -->
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('pedidos') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('vendas') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('pedidos') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons"></div>
                    </div>

                    <!-- BUSCA -->
                    <div class="search-and-filter">
                        <div class="columns is-variable is-2">
                            <div class="column is-two-quarters header-search">
                                <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-busca-pedido-campos" />
                            </div>
                            <!-- Data Inicio-->
                            <div class="column is-one-quarter">
                                <verified-date-picker
                                    :dateType="'startDate'"
                                    :value="datainicio"
                                    @keyup.enter.native="changeStartDate(datainicio)"
                                    :endDate="datafim"
                                    :title="'data-inicio'"
                                    @input="changeStartDate"
                                />
                            </div>
                            <!-- Data Fim-->
                            <div class="column is-one-quarter">
                                <verified-date-picker
                                    :dateType="'endDate'"
                                    @keyup.enter.native="changeEndDate(datafim)"
                                    :value="datafim"
                                    :startDate="datainicio"
                                    :title="'data-fim'"
                                    @input="changeEndDate"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- FILTROS EXTRAS -->
                    <div class="filtros-extras" style="padding-top: 5px">
                        <FiltroPedido @update-filtro="updateFiltro" ref="filtroRef" />
                    </div>
                    <!-- BOTÕES -->
                    <div class="columns mt-2 mb-1">
                        <div class="column is-6 has-text-centered">
                            <button class="delete-btn pl-4 pr-4" @click="confirmCleanFilters">
                                {{ $t('limpar-filtros') }}
                            </button>
                        </div>
                        <div class="column is-6 has-text-centered">
                            <button class="save-btn pl-4 pr-4" @click="pesquisaData">
                                {{ $t('pesquisar') }}
                            </button>
                        </div>
                    </div>

                    <!-- TABELA -->
                    <div class="lps-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" msg="pedido-nodata" />
                        <b-table 
                            v-else 
                            class="data-table" 
                            :data="pedidos" 
                            @sort="sortTable" 
                            backend-sorting
                            striped
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                class="td-center"
                                :key="i"
                                :field="f.key"
                                :label="$t(f.label)"
                                :width="f.width"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                :numeric="f.numeric"
                            >
                                <template v-slot:header>
                                    <div v-if="f.key == 'codigo'" class="header-container">
                                        <div>
                                            {{ $t('codigo') }}
                                        </div>

                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`"
                                            size="is-small"/>
                                    </div>

                                    <span v-else-if="f.key == 'cli_idclienteerp'" class="header-container">
                                        <div>
                                            {{ $t('cod-cliente') }}
                                        </div>

                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`"
                                            size="is-small"/>
                                    </span>

                                    <span v-else-if="f.key == 'cliente'" class="header-container">
                                        <div>
                                            {{ $t('nome') }}
                                            <div class="table-sep" />
                                            {{ $t('razao-social') }}
                                        </div>

                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`" 
                                            size="is-small"/>
                                    </span>

                                    <span v-else-if="f.key == 'cli_cnpjcpf'" class="header-container">
                                        <div>
                                            {{ $t('cnpj') }}
                                        </div>

                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`"
                                            size="is-small"/>
                                    </span>

                                    <span v-else-if="f.key == 'tipopedido'" class="header-container">
                                        <div>
                                            {{ $t('tipo-pedido') }}
                                        </div>
                                        
                                        <b-icon 
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`" 
                                            size="is-small"/>
                                    </span>

                                    <span v-else-if="f.key == 'vendedor'" class="header-container">
                                        <div>
                                            {{ $t('vendedor') }}
                                            {{ $t('tipo-pedido') }}
                                            <div class="table-sep" />
                                            {{ $t('vendedor') }}
                                        </div>
                                        
                                        <b-icon 
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`" 
                                            size="is-small"/>
                                    </span>

                                    <span v-else-if="f.key == 'valortotal'" class="header-container">
                                        <div>
                                            {{ $t('pedido-valortotal') }}
                                        </div>
                                        
                                        <b-icon 
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`" 
                                            size="is-small"/>
                                    </span>

                                    <span v-else-if="f.key == 'datahora'" class="header-container">
                                        <div>
                                            {{ $t('pedido-datahora') }}
                                        </div>

                                        <b-icon 
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`" 
                                            size="is-small"/>
                                    </span>
                                        <span v-else-if="f.key == 'indicerentabilidade'" class="header-container">
                                        <div>
                                            {{ $t('rentabilidade-pedido') }}
                                            <div class="table-sep" />
                                            {{ $t('status-wf') }}
                                        </div>

                                        <b-icon 
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`" 
                                            size="is-small"/>
                                    </span>
                                    <span v-else class="header-container">
                                        <div>
                                            {{ $t('status') }}
                                            <div class="table-sep" />
                                            {{ $t('origem') }}
                                        </div>

                                        <b-icon 
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`" 
                                            size="is-small"/>
                                    </span>
                                </template>
                                <template v-slot="props">
                                    <div v-if="f.key == 'cliente'">
                                        <router-link
                                            :to="{
                                                name: 'ven-pedido-edit',
                                                params: {
                                                    id: props.row.idpedido,
                                                    origem: props.row.pedido_from,
                                                }
                                            }"
                                        >
                                            <!-- <b v-if="props.row.cliente" v-tippy :title="props.row.cliente.nome"> -->
                                            <b v-if="props.row.cliente" :title="props.row.cliente.nome">
                                                {{ cutString(props.row.cliente.nome, 35) }}
                                            </b>
                                            <span v-else>---</span>
                                            <div class="table-sep" />
                                            <!-- <span v-if="props.row.cliente" v-tippy :title="props.row.cliente.rsocial"> -->
                                            <span v-if="props.row.cliente" :title="props.row.cliente.rsocial">
                                                {{ cutString(props.row.cliente.rsocial, 35) }}
                                            </span>
                                            <span v-else>---</span>
                                        </router-link>
                                    </div>

                                    <div v-else-if="f.key == 'cli_idclienteerp'">
                                        <router-link
                                            :to="{
                                                name: 'ven-pedido-edit',
                                                params: {
                                                    id: props.row.idpedido,
                                                    origem: props.row.pedido_from,
                                                }
                                            }"
                                        >
                                            <b>{{ props.row.cliente ? props.row.cli_idclienteerp : '---' }}</b>
                                        </router-link>
                                    </div>

                                    <div v-else-if="f.key == 'cli_cnpjcpf'">
                                        <router-link
                                            :to="{
                                                name: 'ven-pedido-edit',
                                                params: {
                                                    id: props.row.idpedido,
                                                    origem: props.row.pedido_from,
                                                },
                                            }"
                                        >
                                            <b>{{ props.row.cliente ? props.row.cli_cnpjcpf : '---' }}</b>
                                        </router-link>
                                    </div>

                                    <!-- @85011 - Alguns clientes exibem uma cor na rentabilidade -->
                                    <div v-else-if="f.key == 'indicerentabilidade'">
                                        <span 
                                            :style="[ props.row.rentabilidade.cor ? {'color': props.row.rentabilidade.cor} : '' ]"
                                        >
                                            {{ props.row.rentabilidade.exibeRentabilidade ? props.row[f.key] : "---" }}
                                        </span>
                                        <div class="table-sep" />
                                        <!-- Caso tenha workflow da pedidoretorno prioriza ele -->
                                        <div 
                                            class="tag is-success tag-status" 
                                            v-if="!isNull(props.row.statuswf_retorno)"
                                            v-tippy
                                            :title="getT(props.row.statuswf_title_retorno)"
                                        >
                                            {{ props.row.statuswf_retorno }}
                                        </div>
                                        <!-- Caso tenha workflow da pedido na statuswf prioriza ele -->
                                        <div 
                                            class="tag is-success tag-status" 
                                            v-else-if="!isNull(props.row.statuswf_pedido)"
                                            v-tippy
                                            :title="getT(props.row.statuswf_title_pedido)"
                                        >
                                            {{ props.row.statuswf_pedido }}
                                        </div>
                                        <!-- Caso tenha workflow da pedido na statuswfpda prioriza ele -->
                                        <div 
                                            class="tag is-info tag-status" 
                                            v-else-if="!isNull(props.row.statuswfpda)"
                                            v-tippy
                                            :title="getT(props.row.statuswfpda_title)"
                                        >
                                            {{ props.row.statuswfpda }}
                                        </div>
                                        <!-- Caso contrário mostra vazio -->
                                        <div class="tag is-light tag-status" v-else :title="$t('vazio')">---</div>
                                    </div>
                                    <div v-else-if="f.key == 'valortotal'" :title="props.row[f.key]">
                                        {{
                                            props.row[f.key] != undefined
                                                ? getDecimal(props.row[f.key], null, true) 
                                                : '—'
                                        }}
                                    </div>
                                    <div v-else-if="f.key == 'datahora'">
                                        {{ props.row[f.key] | moment('L LT') }}
                                    </div>
                                    <div class="status-pedido has-text-right" v-else-if="f.key == 'venPedidoSituacao'">
                                        <!-- se não tiver status na retorno e tiver na pedido -->
                                        <span
                                            v-if="isNull(props.row.status) && !isNull(props.row[f.key].titulo)"
                                            class="tag tag-status"
                                            :style="{ backgroundColor: `#${props.row[f.key].cor}` }"
                                        >
                                            <p :style="'color: '+getTextColor('#'+props.row[f.key].cor)">{{ props.row[f.key].titulo }}</p>
                                        </span>
                                        <!-- se tiver status na retorno -->
                                        <div 
                                            class="tag is-success tag-status" 
                                            v-else-if="!isNull(props.row.status)"
                                        >
                                            {{ props.row.status }}
                                        </div>
                                        <!-- se não tiver status na pedido e nem na retorno -->
                                        <div class="tag is-light tag-status" v-else :title="$t('vazio')"> {{ $t('nao-definido')  }} </div>
                                        <br />
                                        <!-- @84601 - validacao das tags conforme a origem -->
                                        <span
                                            v-if="origensFV.includes(props.row.origem)"
                                            class="tag is-success tag-status"
                                        >
                                            {{ props.row.origem }}
                                        </span>
                                        <span
                                            v-else-if="origensB2B.includes(props.row.origem)"
                                            class="tag is-info tag-status"
                                        >
                                            {{ props.row.origem }}
                                        </span>
                                        <span v-else class="tag is-warning tag-status">
                                            {{
                                                props.row.origem === 'sem-origem'
                                                    ? $t(props.row.origem)
                                                    : props.row.origem
                                            }}
                                        </span>
                                    </div>
                                    <div v-else-if="f.key == 'codigo'">
                                        {{ getCodigo(props.row) }}
                                    </div> 
                                    
                                    <div v-else-if="f.key == 'tipopedido'">
                                        {{ props.row.tipopedido }}
                                        <div class="table-sep" />
                                        {{ props.row.vendedor }}
                                    </div>

                                    <div v-else>
                                        {{ props.row[f.key] }}
                                    </div>
                                </template>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import Message from '@/models/Message';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import FiltroPedido from '@/components/vendas/pedido/FiltroPedido';
import PedidoService from '@/services/PedidoService';
import ParametrizacaoService from '@/services/ParametrizacaoService';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('ven-pedido') && to.name != 'ven-pedido-list') {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
        FiltroPedido,
    },
    data() {
        return {
            rotaAninhada: false,
            service: new PedidoService(this.$http, this.$router),
            serviceParametrizacao: new ParametrizacaoService(this.$http, this.$router),
            paramListaClientePedido: {},
            formatter: new Intl.NumberFormat(),
            msgs: [],
            pedidos: [],
            fields: [
                { 
                    key: 'codigo', 
                    label: 'codigo',
                    width: null, 
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                { 
                    key: 'cli_idclienteerp', 
                    label: 'cod-cliente', 
                    width: null, 
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                { 
                    key: 'cliente', 
                    label: 'nome', 
                    width: null, 
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                { 
                    key: 'cli_cnpjcpf', 
                    label: 'cnpj', 
                    width: null, 
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                { 
                    key: 'tipopedido', 
                    label: 'tipo-pedido', 
                    width: null, 
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                {
                    key: 'valortotal',
                    label: 'pedido-valortotal',
                    width: null,
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                { 
                    key: 'indicerentabilidade', 
                    label: 'rentabilidade-pedido', 
                    width: null, 
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                {
                    key: 'datahora',
                    label: 'pedido-datahora',
                    width: 100,
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                {
                    key: 'venPedidoSituacao',
                    label: 'status',
                    width: null,
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
            ],
            filtros: {
                tiposPedido: [],
                formasPagamento: [],
                prazosPagamento: [],
                tabelaPreco: [],
                transportadoras: [],
                tipoFrete: [],
                empresas: [],
                vendedores: [],
                datainicio: null,
                datafim: null,
                status: null,
                origem: 0,
                motivoOrigem: []
            },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            column: 'datahora',
            order: 'desc',
            searchQuery: '',
            datafim: new Date(),
            datainicio: new Date(this.$moment().subtract(30, 'days')),
            permissao: {},
            // @84601 - listas utilizados para verificar qual cor da tag será utilizado.
            origensFV: ['FV', 'WEBFV'],
            origensB2B: ['B2B MOBILE', 'B2B WEB'],
        };
    },
    created() {
        this.rotaAninhada = this.$route.name.includes('ven-pedido') && this.$route.name !== 'ven-pedido-list';

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-pedido');
        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'pedidos' },
            });
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.isLoading = true;
        this.serviceParametrizacao
            .getConfigByNomeIdusuario("LISTACLIENTEPEDIDO", 0)
            .then((result) => {
                this.paramListaClientePedido = result.content || { valor: null };
            })
            .finally(() => {
                this.carregarDados();
            });
    },
    methods: {
        getCodigo(pedido) {
            if (this.paramListaClientePedido.valor == "1") {
                return pedido.codigo;
            }
            return pedido.idpedidoerp;
        },
        getTextColor(backgroundColor) {

            if(backgroundColor.length <= 2){
                return "black"
            } 

            const color = backgroundColor.slice(1);

            const r = parseInt(color.substring(0, 2), 16);
            const g = parseInt(color.substring(2, 4), 16);
            const b = parseInt(color.substring(4, 6), 16);

            const brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;

            return brightness > 128 ? 'black' : 'white';
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        updateFiltro(filtro) {
            let nome = filtro.nomeFiltro;
            switch (nome) {
                case 'tiposPedido':
                    this.filtros.tiposPedido = filtro.valor;
                    break;
                case 'formas-pagamento':
                    this.filtros.formasPagamento = filtro.valor;
                    break;
                case 'prazosPagamento':
                    this.filtros.prazosPagamento = filtro.valor;
                    break;
                case 'tabelaPreco':
                    this.filtros.tabelaPreco = filtro.valor;
                    break;
                case 'transportadoras':
                    this.filtros.transportadoras = filtro.valor;
                    break;
                case 'tiposFrete':
                    this.filtros.tipoFrete = filtro.valor;
                    break;
                case 'empresas':
                    this.filtros.empresas = filtro.valor;
                    break;
                case 'vendedores':
                    this.filtros.vendedores = filtro.valor;
                    break;
                case 'status':
                    this.filtros.status = filtro.valor;
                    break;
                case 'origem':
                    this.filtros.origem = filtro.valor;
                    break;
                case 'motivo-origem':
                    this.filtros.motivoOrigem = filtro.valor;
                    break;
            }
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            let filtro = {
                tiposPedido: this.filtros.tiposPedido
                    ? this.filtros.tiposPedido.map((e) => e.idtipopedido)
                    : [],
                formasPagamento: this.filtros.formasPagamento
                    ? this.filtros.formasPagamento.map((e) => e.idformapagto)
                    : [],
                prazosPagamento: this.filtros.prazosPagamento
                    ? this.filtros.prazosPagamento.map((e) => e.idprazopagto)
                    : [],
                tabelaPreco: this.filtros.tabelaPreco
                    ? this.filtros.tabelaPreco.map((e) => e.idtabpreco)
                    : [],
                transportadoras: this.filtros.transportadoras
                    ? this.filtros.transportadoras.map((e) => e.idtransportadora)
                    : [],
                tipoFrete: this.filtros.tipoFrete ? this.filtros.tipoFrete.map((e) => e.idtipofrete) : [],
                empresas: this.filtros.empresas ? this.filtros.empresas.map((e) => e.idempresa) : [],
                vendedores: this.filtros.vendedores ? this.filtros.vendedores.map((e) => e.idusuario) : [],
                origem: this.filtros.origem,
                inicio: this.datainicio ? this.$moment(this.datainicio).format('YYYY-MM-DD') : new Date(this.$moment().subtract(30, 'days')),
                motivoOrigem: this.filtros.motivoOrigem || [],
                fim: this.datafim ? this.$moment(this.datafim).format('YYYY-MM-DD') : new Date(),
                status: this.filtros.status,
            };
            this.$axios.post('/vendas/pedido.json', filtro, {
                params: {
                    page: currentPage - 1,
                    limit: this.pagination.perPage,
                    order: this.order,
                    column: this.column,
                    contagem: 0,
                    param: this.searchQuery
                },
            })
            .then((response) => {
                if(response.data.status != 200){
                    this.isEmpty = true;
                    this.msgs.push(new Message('error', 'pedidos-erro', true));
                } else {
                    this.pagination.totalRows = response.data.totalElements;
                    this.pedidos = response.data.content;
                    this.isEmpty = this.pedidos.length <= 0;
                }
            })
            .catch((error) => {
                this.isEmpty = true;
                this.msgs.push(new Message('error', 'pedidos-erro', true));
            })
            .finally((_) => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        getDescricaoStatus(sigla) {
            const mapa = {
                PC: "PEDIDO CRIADO",
                PA: "PEDIDO ALTERADO",
                PT: "PEDIDO TRANSMITIDO",
            };
            return mapa[sigla];
        },
        onSearch(text) {
            this.searchQuery = this.removeAcentos(text);
            this.carregarDados();
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;

            this.fieldAnterior 
                ? this.fields.find(obj => obj.key == this.fieldAnterior).iconeAtivo = false 
                : this.fieldAnterior = field;
            
            let fieldItem = this.fields.find(obj => obj.key == field)
            fieldItem.order = this.order;
            fieldItem.iconeAtivo = true;

            this.fieldAnterior = field;

            this.carregarDados();
        },
        confirmCleanFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: this.limparFiltros,
            });
        },
        limparFiltros() {
            this.filtros.tiposPedido = [];
            this.filtros.formasPagamento = [];
            this.filtros.prazosPagamento = [];
            this.filtros.tabelaPreco = [];
            this.filtros.transportadoras = [];
            this.filtros.tipoFrete = [];
            this.filtros.empresas = [];
            this.filtros.vendedores = [];
            this.filtros.origem = 0;
            // this.filtros.origem = [];
            this.filtros.motivoOrigem = [];
            this.filtros.datafim = new Date();
            this.filtros.datainicio = new Date(this.$moment().subtract(30, 'days'));
            this.filtros.status = null;
            this.carregarDados();
            this.$refs.filtroRef.limparFiltrosSelecionados();
        },
        pesquisaData() {
            if (this.validateDatas()) {
                this.carregarDados();
            }
        },
        // Recebe o $emit do VerifiedDatePicker, adiciona o valor na variavel local que retorna para a prop do VerifiedDatePiker
        changeStartDate(date) {
            this.datainicio = date;
            this.carregarDados();
        },
        changeEndDate(date) {
            this.datafim = date;
            this.carregarDados();
        },
        validateDatas() {
            let valid = true;
            let m_ini = this.$moment(this.filtros.datainicio);
            let m_fim = this.$moment(this.filtros.datafim);

            if (m_fim.isBefore(m_ini)) {
                this.$root.showMessage('error', 'msg-erro-data-inicial-final', true);
                valid = false;
            }
            return valid;
        },
        handleDateChange(nova_data, campo) {
            switch (campo) {
                case 'inicio':
                    this.filtros.datainicio = this.$moment(nova_data).format('YYYY-MM-DD');
                    break;
                case 'fim':
                    this.filtros.datafim = this.$moment(nova_data).format('YYYY-MM-DD');
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    min-height: calc(100% - 50px);
    position: relative;

    .periodo-input {
        height: 40px;
    }

    .is-orange {
        background-color: #ef8419;
        color: #fff;
    }

    .status-tag {
        margin-top: 10px;
    }

    .datepicker input {
        height: 40px !important;
    }

    .pedidos .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;

        .columns {
            width: 100%;
        }
    }

    .lps-table {
        padding-top: 0px;
        font-size: 14px;
    }

    .empty-list {
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 300px);

        .empty-inner {
            text-align: center;

            .empty-icon {
                fill: #898989;
                width: 50px !important;
                height: 50px !important;
            }

            .empty-text {
                font-weight: 600;
            }
        }
    }

    .listing-link {
        font-weight: 600;
        cursor: pointer;
        color: $primary-color;

        &:hover {
            text-decoration: underline;
        }
    }

    .status-pedido {
        font-weight: 600;
        width: 100%;
        .tag-status {
            margin-bottom: 5px;
        }
    }

    .filtros-extras {
        font-size: 12px;
        margin-right: 8px;
    }

    .pedido-processando {
        color: $yellow;
    }
    .pedido-naoenviado {
        color: $red-alert;
    }
    .pedido-transmitido {
        color: $green-alert;
    }

    @media only screen and (max-width: 768px) {
        .header-search {
            padding-bottom: 0;
        }

        .header-filter {
            padding-top: 0;
        }
    }
}

.control-buttons {
    padding-top: 10px;
}

.header-container {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
}

.status-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center; /* centraliza horizontalmente */
    align-items: center;     /* centraliza verticalmente */
    font-weight: bold;
    font-size: 0.8rem;
    color: white;
    background-color: var(--primary-color);
    transition: background-color 0.3s, color 0.3s;
    text-align: center;      /* garante centralização do texto */
}

</style>
